const Ext = window.Ext;
export default Ext;


// WEBPACK FOOTER //
// ./web/js/alias/extjs.js